import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import DetailsCard from 'bundles/apex/card/details';
import PropertyType from 'bundles/apex/deals/show/listing/values/property_type';
import Text from 'bundles/apex/deals/show/listing/values/value';
import { getLocation } from  'bundles/apex/deals/helpers';
import { getLocationLabel } from 'bundles/apex/deals/helpers/labels';

export const PropertyCard = ({ fields, isParentDeal, listing, project }) => {
  const source = isParentDeal ? project : listing;

  return (
    <DetailsCard label="Marketing Property">
      <Text name="address" />
      {!isParentDeal && <Text label="Address 2" name="address2" />}
      <Text label={getLocationLabel(source, fields)} name="location" value={getLocation(source)} />
      <Text name="county" />
      <PropertyType source={source} />
      {!isParentDeal && (
        <Text
          label={source.propertyType === 'Land' ? 'Lot Size' : 'Building Size'}
          name="sizeLabel"
        />
      )}
      {source.propertyType === 'Office' && <Text name="buildingClass" />}
      <Text name="locationDescription" />
    </DetailsCard>
  );
};

PropertyCard.propTypes = {
  fields: PropTypes.object.isRequired,
  isParentDeal: PropTypes.bool,
  listing: PropTypes.object,
  project: PropTypes.object
};

const mapStateToProps = ({ deal, fields }) => ({
  listing: deal.listing,
  isParentDeal: deal.parent,
  project: deal.project,
  fields: fields,
});

export default connect(mapStateToProps)(PropertyCard);
